// extracted by mini-css-extract-plugin
export default {"imageDirectionLTR":"YofKFE","imageDirectionLtr":"YofKFE","imageContainer":"P37eeY","defaultImage":"Il60Mt","defaultImageMobile":"awuoxZ"};